import Col from '@loggi/ui/components/col';
import PropTypes from 'prop-types';
import React from 'react';
import Text from '@loggi/ui/components/text';
import colors from '@loggi/ui/components/utils/colors';
import Divider from '@loggi/ui/components/divider';
import styles from './recipient-pickup-text.styles.scss';
import {
  MAX_PICKUP_DATE_TEXT,
  TRACKING_CODE_TEXT
} from './recipient-pickup-text.constants';
import getFormattedDate from '../utils/datetime-format';

export const RECIPIENT_PICKUP_TEXT_ID = 'recipient-pickup-text';

export default function RecipientPickupText({
  trackingCode,
  maxPickupTime,
  gutter
}) {
  return (
    <Col
      className={styles.recipientPickupText}
      flexDirection="row"
      gutter={gutter}
      data-testid={RECIPIENT_PICKUP_TEXT_ID}
    >
      <Col flexDirection="column" className="pickup-time-detail">
        <Text size="300" color={colors.type.STORM_500}>
          {MAX_PICKUP_DATE_TEXT}
        </Text>
        <Text size="300" color={colors.type.SMOKE_900}>
          {getFormattedDate(maxPickupTime)}
        </Text>
      </Col>
      <Col className="separator">
        <Divider
          direction="vertical"
          color={colors.type.SMOKE_100}
          gutter="normal"
        />
      </Col>
      <Col flexDirection="column" className="tracking-code-detail">
        <Text size="300" color={colors.type.STORM_500}>
          {TRACKING_CODE_TEXT}
        </Text>
        <Text size="300" color={colors.type.SMOKE_900}>
          {trackingCode}
        </Text>
      </Col>
    </Col>
  );
}

RecipientPickupText.displayName = 'AddressText';
RecipientPickupText.defaultProps = {
  trackingCode: null,
  maxPickupTime: null,
  gutter: null
};
RecipientPickupText.propTypes = {
  trackingCode: PropTypes.string,
  maxPickupTime: PropTypes.number,
  gutter: PropTypes.shape({
    top: PropTypes.string,
    right: PropTypes.string,
    bottom: PropTypes.string,
    left: PropTypes.string
  })
};
